module.exports = __webpack_public_path__ + "static/media/museum.86d2b81f.svg";